import { ArrowBack, EditRounded, MoreVert } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import _, { isEmpty } from 'lodash';
import React, { Component } from 'react';
import SwipeableTabs from '../../../../container/MUI/SwipeableTabs';
import { newEquipement } from '../../../../store/actions/equipementAction';
import Dialog from '../../../common/Dialog';
import RecupPreview from '../Contract/RecupPreview';
import RemisePreview from '../Contract/RemisePreview';
import Equipements from '../Forms/Equipements';
import EquipementDetails from './EquipementDetails';
import EquipementSpendings from './EquipementSpendings';
import EquipementStats from './EquipementStats';
import LoanHistory from './LoanHistory';

class EquipementSingle extends Component {
    state = {  
        openContract: false,
        user: {},
        loan:{},
        index: 0,
    }
    componentDidMount = async () => {

        if (isEmpty(this.props.LOANS_BY_EQUIP[this.props.EQUIP.equipement_id])){
            await this.props.fetchEquipementLoans(this.props.EQUIP.equipement_id)
        }
    }

    
    filterList = () => {
        const { EQUIP, field, LOANS } = this.props;
        let list = []
        // if (EQUIP.equipement_type === "vehicule") {
        //     equip = VEHICULES[id]
        //     field = "loan_vehicule"
        // }
        // if (EQUIP.equipement_type === "equipement") {
        //     equip = EQUIPEMENTS[id]
        //     field = "loan_equipement"
        // }
            
        // fetch loans for this only


        if ( EQUIP ) {
            // Object.values(LOANS).forEach(obj => {
            //     console.log('====================================');
            //     console.log({obj});
            //     console.log('====================================');
            // })
            list = Object.values(LOANS).filter(obj => (obj[field] === EQUIP.equipement_id) )
            // this.setState({error: ""})
            console.log('====================================');
            console.log({list, EQUIP});
            console.log('====================================');
        } 
        // else {
        //     this.setState({error: "Equipement Introuvable"})
        // }
        return list
    }
        
    handleContract = (loan, user, contract) => {
        this.setState({
            loan,
            user,
            [contract]: true
        })
    }
    handleUpdate = () => {
        this.setState({
            openUpdate: true,
        })
    }

    render() {
        const { EQUIP, LOANS_BY_EQUIP } = this.props;
        const { loan, user, openContract, openEndContract, index, openUpdate } = this.state;

        // let list = this.filterList()
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            <Dialog
                close={this.props.close}
                maxWidth="lg"
                fullScreen
                scroll="paper"
                title={`${EQUIP.equipement_ref} - ${EQUIP.equipement_name}`}
                appBar
                // secondaryAction={
                //     <IconButton
                //         onClick={this.handleUpdate}
                //         size="large">
                //         <EditRounded />
                //     </IconButton>
                // }
            >
                {/* {openUpdate &&
                    <Equipements
                        update
                        equipement={EQUIP}
                        type={EQUIP.equipement_type}
                        {...this.props}
                    />
                } */}
                {(openContract || openEndContract) ?
                    <Box>
                        <IconButton
                            color="inherit"
                            onClick={() => this.setState({openContract: false, openEndContract: false, user: {}, loan: {}})}
                            aria-label="Close"
                            size="large">
                            <ArrowBack />
                        </IconButton>
                        {openEndContract ?
                            <RecupPreview
                                loan={loan}
                                user={user}
                                EQUIP={EQUIP}
                            />
                        :
                            <RemisePreview
                                loan={loan}
                                user={user}
                                EQUIP={EQUIP}
                            />
                        }
                    </Box>
                :
                <Box>
                    <SwipeableTabs
                        labels={["Infos", "Historique", "Dépenses", "Statistiques"]}
                        returnIndex={(index) => this.setState({ index })}
                        tab={index}
                    >
                        {/* {index == 0 && */}
                            <Box p={3}>
                                <EquipementDetails
                                    {...this.props}
                                    loans={LOANS_BY_EQUIP[this.props.EQUIP.equipement_id] && Object.values(LOANS_BY_EQUIP[this.props.EQUIP.equipement_id])}
                                />
                            </Box>
                        {/* }
                        {index == 1 && */}
                            <Box p={3}>
                                <LoanHistory
                                    {...this.props}
                                    list={LOANS_BY_EQUIP[this.props.EQUIP.equipement_id] && Object.values(LOANS_BY_EQUIP[this.props.EQUIP.equipement_id])}
                                    handleContract={this.handleContract}
                                />
                            </Box>
                        {/* }
                        {index == 2 && */}
                            <Box p={3}>
                                <EquipementSpendings
                                    equipement={EQUIP}
                                    eType={EQUIP.type}
                                    {...this.props}
                                />
                            </Box>
                        {/* } */}
                            <Box p={3}>
                                <EquipementStats
                                    equipement={EQUIP}
                                    eType={EQUIP.type}
                                    {...this.props}
                                />
                            </Box>
                    </SwipeableTabs>
                    </Box>
                }

            </Dialog>
        );
    }
}

export default EquipementSingle;